<template>
  <!--个人用户签章设置-->
  <div class="person-set">
<!--    <role-tab-->
<!--      :tabs="{-->
<!--        // haveBind 表示是否要用 binds中的数据-->
<!--        haveBind: false,-->
<!--        binds: [],-->
<!--      }"-->
<!--      @change="tabHand"-->
<!--    />-->
    <!--    手写章-->
    <h1 class="com-title com-ht"><i></i>个人签章</h1>
    <!--  手写章接口列表    -->
<!--    <div class="box-wrap">-->
<!--      <div-->
<!--        class="temone"-->
<!--        v-if="ManualSignatureList && ManualSignatureList.handSignUrl"-->
<!--      >-->
<!--        <div class="t-box">-->
<!--          &lt;!&ndash; 是默认签章&ndash;&gt;-->
<!--          <img v-if="1" class="mr-label" src="/images/web/icon-default.png" />-->
<!--          <img class="y-img" :src="ManualSignatureList.imgSrc" title="" />-->
<!--          <div class="msk">-->
<!--            &lt;!&ndash;              <span&ndash;&gt;-->
<!--            &lt;!&ndash;                class="setmr-btn"&ndash;&gt;-->
<!--            &lt;!&ndash;                v-if="!(item.defaultChapter && item.defaultChapter === 1)"&ndash;&gt;-->
<!--            &lt;!&ndash;                @click="setDefaultSeal(item.signId)"&ndash;&gt;-->
<!--            &lt;!&ndash;              >设为默认&ndash;&gt;-->
<!--            &lt;!&ndash;              </span>&ndash;&gt;-->
<!--            <span-->
<!--              class="el-icon-edit-outline"-->
<!--              style="margin-top: 1px"-->
<!--              @click="handWritingChapterEdit"-->
<!--              title="修改"-->
<!--            ></span>-->
<!--            &lt;!&ndash;            <span&ndash;&gt;-->
<!--            &lt;!&ndash;              class="el-icon-delete"&ndash;&gt;-->
<!--            &lt;!&ndash;              @click="delChapter(item.signId)"&ndash;&gt;-->
<!--            &lt;!&ndash;              title="删除"&ndash;&gt;-->
<!--            &lt;!&ndash;            ></span>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--        <p title="手写章">手写章</p>-->
<!--      </div>-->
<!--      <div class="temone add" v-else @click="handWritingChapterEdit">-->
<!--        <span class="el-icon-plus"></span>-->
<!--      </div>-->
<!--    </div>-->
    <!--    =====================   t图形章-->
    <h1 class="com-title com-ht" v-if="isAddSign">
      <el-button size="small" type="primary" @click="isAddSign = false" class="return-a"
      >返回</el-button>
    </h1>

<!--    <h1 class="com-title com-ht" v-else><i></i>图形章&nbsp;&nbsp;<el-tooltip effect="dark" content="当发起方允许使用图形章时，可使用下列已创建好的图形章" placement="right">-->
<!--      <span class="el-icon-question"></span>-->
<!--    </el-tooltip></h1>-->
    <div class="box">
      <!--新增章-->
      <el-row v-if="isAddSign" class="add-seal-box">
        <el-col :span="8" :offset="2">
          <div class="priview-img">
            <img :src="previewSealUrl" />
          </div>
        </el-col>
        <el-col :span="10" :offset="2">
          <el-form
            :model="sealParam"
            :rules="sealRules"
            size="small"
            ref="sealForm"
          >
            <el-form-item>签章名称</el-form-item>
            <el-form-item prop="chapterName">
              <el-input
                v-model="sealParam.chapterName"
                placeholder="必填，1-50个字符"
              />
            </el-form-item>
            <el-form-item>
              <b><input type="radio" checked />签章样式</b>
            </el-form-item>
            <el-form-item>
              <div @click="sealParam.color = 0" class="red-seal"></div>
              <div @click="sealParam.color = 1" class="blue-seal"></div>
            </el-form-item>
            <el-form-item>
              <el-row>
                <el-col :span="8">
                  <div
                    @click="
                      sealParam.path = 0;
                      sealParam.fontType = 0;
                    "
                    :class="[
                      'seal-dome',
                      sealParam.path === 0 && sealParam.fontType === 0
                        ? 'active'
                        : '',
                    ]"
                  >
                    <img src="/images/chap_demo_1.jpg" alt="" />
                  </div>
                </el-col>
                <el-col :span="8">
                  <div
                    @click="
                      sealParam.fontType = 0;
                      sealParam.path = '';
                    "
                    :class="[
                      'seal-dome',
                      sealParam.path === '' && sealParam.fontType === 0
                        ? 'active'
                        : '',
                    ]"
                  >
                    <img src="/images/chap_demo_2.jpg" alt="" />
                  </div>
                </el-col>
                <el-col :span="8">
                  <div
                    @click="
                      sealParam.fontType = 0;
                      sealParam.path = 1;
                    "
                    :class="[
                      'seal-dome',
                      sealParam.path === 1 && sealParam.fontType === 0
                        ? 'active'
                        : '',
                    ]"
                  >
                    <img src="/images/chap_demo_3.jpg" alt="" />
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button @click="createSeal">立即生成</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!--章列表-->
      <div class="box-wrap" v-if="!isAddSign">
        <!--  手写章接口列表    -->
        <div>
          <div
            class="temone"
            v-if="ManualSignatureList && ManualSignatureList.handSignUrl"
          >
            <div class="t-box">
              <!-- 是默认签章-->
              <img v-if="1" class="mr-label" src="/images/web/icon-default.png" />
              <img class="y-img" :src="ManualSignatureList.imgSrc" title="" />
              <div class="msk">
                <!--              <span-->
                <!--                class="setmr-btn"-->
                <!--                v-if="!(item.defaultChapter && item.defaultChapter === 1)"-->
                <!--                @click="setDefaultSeal(item.signId)"-->
                <!--              >设为默认-->
                <!--              </span>-->
                <span
                  class="el-icon-edit-outline"
                  style="margin-top: 1px"
                  @click="handWritingChapterEdit"
                  title="修改"
                ></span>
                <!--            <span-->
                <!--              class="el-icon-delete"-->
                <!--              @click="delChapter(item.signId)"-->
                <!--              title="删除"-->
                <!--            ></span>-->
              </div>
            </div>
            <p title="手写章">手写章</p>
          </div>
          <div class="temone add" v-else @click="handWritingChapterEdit">
            <span class="el-icon-plus"></span>
          </div>
        </div>
        <div class="temone" v-if="defalutChapter">
          <div class="t-box">
            <img
              class="y-img"
              :src="'data:image/jpeg;base64,' + this.defalutChapter.signName"
            />
          </div>
          <p title="系统图形章">系统图形章</p>
        </div>
        <template v-for="(item, index) in chapterList">
          <div
            class="temone"
            :key="index"
            v-if="chapterList"
          >
            <div class="t-box">
              <!-- 是默认签章-->
              <!--            <img-->
              <!--              v-if="item.defaultChapter && item.defaultChapter === 1"-->
              <!--              class="mr-label"-->
              <!--              src="/images/web/icon-default.png"-->
              <!--            />-->
              <img class="y-img" :src="item.signUrl" :title="item.signName" />
              <div class="msk">
                <!--              <span-->
                <!--                class="setmr-btn"-->
                <!--                v-if="!(item.defaultChapter && item.defaultChapter === 1)"-->
                <!--                @click="setDefaultSeal(item.signId)"-->
                <!--                >设为默认-->
                <!--              </span>-->
                <span
                  class="el-icon-edit-outline"
                  style="margin-top: 1px"
                  @click="openFileUploadDialog(item)"
                  title="修改"
                ></span>
                <span
                  class="el-icon-delete"
                  @click="delChapter(item.signId)"
                  title="删除"
                ></span>
              </div>
            </div>
            <p :title="`${item.signName}(ID:${item.signId})`">
              {{ `${item.signName}(ID:${item.signId})` }}
            </p>
          </div>
        </template>
        <el-popover
        placement="right"
        width="200"
      >
        <div class="popover-style">
          <el-button size="mini" @click="gotoAuth(0)"
          >本地上传
          </el-button
          >
          <el-button size="mini" @click="gotoAuth(1)">在线制作</el-button>
        </div>
        <div slot="reference" class="temone add">
          <span class="el-icon-plus"></span>
        </div>
        </el-popover>
      </div>
    </div>
<!--    授权章 -->
    <div v-if="authChapterArr.length" style="padding-bottom: 30px">
      <div v-for="(item, index) in authChapterArr" :key="index">
        <h1 class="com-title com-ht"><i></i>授权给我的-<img
          src="/images/icon/dingIcon.png"
          alt="钉钉"
          width="20px"
          v-if="userNameFn(item.corpUserId).userStemFrom === -16 && !isInDingTalk"
        />{{userNameFn(item.corpUserId).corpName}}</h1>
        <div class="box-wrap">
          <template v-if="item.list && item.list.length > 0">
            <div class="temone" v-for="(childItem, childIndex) in item.list" :key="childIndex">
              <div class="t-box">
                <img class="y-img" :src="childItem.signUrl" :title="childItem.sealName" />
              </div>
              <p :title="`${childItem.sealName}(ID:${childItem.corpSealId})`">
                {{ `${childItem.sealName}(ID:${childItem.corpSealId})` }}
              </p>
              <div class="info_box" v-if="isInDingTalk ? childItem.dingTalkFlow : childItem.flowDetail">
                <el-popover placement="top-start" trigger="click">
                  <div style="padding: 10px;font-weight: bold;">
                    <p>
                      {{ isInDingTalk ? childItem.dingTalkFlow.flowName : childItem.flowDetail.flowName }}
                    </p>
                    <div style="height:125px;overflow-y:scroll;">
                      <approval-process
                        :flowInfo="computeInfo(isInDingTalk ? childItem.dingTalkFlow : childItem.flowDetail)"
                        :orderFlag="isInDingTalk ? childItem.dingTalkFlow.flowType : childItem.flowDetail.orderFlag"
                      ></approval-process>
                    </div>
                  </div>
                  <span class="approve_info" slot="reference">{{
                  isInDingTalk ? childItem.dingTalkFlow.flowName : childItem.flowDetail.flowName
                }}</span>
                </el-popover>
              </div>
            </div>
          </template>
          <no-data  v-else-if="!item.sealName" text="企业暂未授权印章给您，如需使用请联系管理员" slot="empty" />
        </div>
      </div>
    </div>

    <!--修改章弹窗-->
    <el-dialog title="修改签章" :visible.sync="isUpdateSeal" width="550px">
      <el-form
        :model="updateInfo"
        :rules="sealRules"
        size="small"
        class="update-seal"
        ref="updateSeal"
        :key="updateInfo.signId"
      >
        <el-row>
          <el-col :span="12">
            <div class="seal-show">
              <img :src="updateInfo.sealUrl" />
            </div>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="chapterName">
              <p>签章名字</p>
              <el-input
                v-model="updateInfo.chapterName"
                placeholder="支持1-50个字符"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="text-center footer">
          <el-button @click="updateSeal" type="danger" class="btn"
            >保存</el-button
          >
          <el-button @click="isUpdateSeal = false" class="btn btn-cancel"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--修改手写章二维码-->
    <el-dialog
      :visible.sync="visibleSealDialog"
      width="340px"
      class="modifi-seal"
    >
      <template v-if="handWritingChapterInfo">
        <qrcode-vue
          :value="handWritingChapterInfo.url"
          :size="300"
          leave="H"
          key="seal"
        />
        <p class="text-center" style="font-size: 12px; margin-bottom: 15px">
          请使用手机扫码设置签字！
        </p>
        <el-button type="primary" size="small" style="width: 100%" @click="addUserLocalSignFn">图片上传</el-button>
      </template>
    </el-dialog>
    <goto-auth :authDialog.sync="authDialog"></goto-auth>
    <!-- 【1714】需求本地上传图片制作印章 -->
    <create-local-seal v-if="localAddSign" :userType="0" :newSign="newSign" @signCreated="signCreated"></create-local-seal>
    <userLocalSeal v-if="userLocalAddSign" :newSign="handWritingChapterInfo" @signCreated="signCreated"></userLocalSeal>
    <!-- 在线制作印章弹窗 -->
    <!-- <sign-on-line
      v-if="onLineVise"
      @viseControl="onLineVise = !onLineVise"
    ></sign-on-line> -->
  </div>
</template>

<script>
  import { storeAllToken } from "../../assets/js/http-serve/corp/common";
  import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
  import approvalProcess from "@/components/approval-process/index";
  import RoleTab from "@/components/role-tab";
import {
  fileOperShow,
  postFileTempUpload,
  ApiMethods
} from "../../assets/js/http-serve/http-methods";
import EntSignController from "../../assets/js/http-serve/entSignController";
import { getFix } from "../../assets/js/lib/common";
import UserSign from "../../assets/js/http-serve/userSign";
import QrcodeVue from "qrcode.vue";
import GlobalConfig from "../../assets/js/config/global";
import {isInDingTalk} from "../../assets/js/utils/ding-env";
import createLocalSeal from "../../components/tpl-editor/localSeal.vue"
import userLocalSeal from "../../components/tpl-editor/userLocalSeal.vue"

export default {
  name: "personSet",
  components: {
    QrcodeVue,
    RoleTab,
    createLocalSeal,
    userLocalSeal,
    approvalProcess,
  },
  props: ['menus'],
  data () {
    return {
      userLocalAddSign: false,
      newSign:{},
      isInDingTalk,
      defalutChapter: null,
      authChapterArr: [],
      chapterList: [],
      //手写章
      ManualSignatureList: {},
      // 上传章的参数
      chapterParam: {
        targetId: null,
        targetFix: null,
        signName: null,
        signId: null,
        signUrl: ""
      },
      // 修改章
      isUpdateSeal: false,
      updateInfo: { signId: "", chapterName: "", sealUrl: "" },
      // 添加章
      isAddSign: false,
      localAddSign:false,
      sealParam: {
        fontType: 0,
        color: 0,
        path: 0,
        chapterName: "",
        signId: null
      },
      sealRules: {
        chapterName: [
          { required: true, message: "请输入签章名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "签章名称长度在1-50个字符之间",
            trigger: "blur"
          }
        ]
      },
      previewSealUrl: "",
      loading: null,
      authDialog: false,
      visibleSealDialog: false, //false二维码弹窗
      handWritingChapterInfo: {} //手写章二维码数据
    };
  },
  beforeMount () {
    try {
      if (this.$store.getters.currentAuthUser.userType == 1) {
        this.$router.push({
          path: "/tpl/entSign"
        });
      }
    } catch (e) {
      console.log(e);
    }
  },
  mounted () {
    this.getChapterList();
    this.getPreviewSeal();
    this.hasManualSignature();
    storeAllToken(res => {
      if(isInDingTalk){
      const DINGUSER = JSON.parse(sessionStorage.getItem('dingloginInfo'));
      const CURR = this.bindCorpUsers.find(item => item.corpId === DINGUSER.jzqCorpId);
      (res.corpUserId == CURR.corpUserId) && this.getBindChapterList(res);
    }else{
      this.getBindChapterList(res);
    }
    });
  },
  watch: {
    sealParam: {
      handler (val) {
        this.getPreviewSeal();
      },
      deep: true
    }
  },
  computed: {
    bindCorpUsers() {
      return this.$store.getters.allAuthUser.bindCorpUsers;
    }
  },
  methods: {
    //userNameFn
    userNameFn(corpUserId) {
      let arr = this.bindCorpUsers.filter(item => {
        return +item.corpUserId === +corpUserId
      })
      return arr.length ? arr[0]: '';
    },
    computeInfo(obj) {
      let nameList = [],list=[];
      if(isInDingTalk){
        // 钉钉流程 flowType 1:顺序审（多层，每层一个），2：会审（单层，一层多个
        if(obj){
          const {nodes} = obj.flowParam || {};
          nodes && nodes.forEach((node) => {
            nameList.push(...(node.userApproveUsers.map(user => user.name)))
          })
          list = nameList.map(name => {
            return {partyName: name};
          });
        }
      }else{
        const keyStr = obj.orderFlag ? "->" : "、"
        nameList =obj.allPartName.split(keyStr);
        list = nameList.map(name => {
          return {partyName: name};
        });
      }
      return list;
    },
    // 获取章列表
    async getBindChapterList(tokenRes) {
      this.loadingStart();
      let res = await ApiCorpMethods.SealController.listSeals({ _ctToken: tokenRes.token });
      if (res.success) {
        const {data}=res;
        let list = data ? data : [];
        list.forEach(t => {
          t.signUrl = fileOperShow(t.sealFile);
        });

        this.authChapterArr.push({corpUserId: tokenRes.corpUserId, list});
      }
      this.loadingClose();
    },
    // 创建签章成功
    signCreated(refresh){
      this.localAddSign = false
      this.visibleSealDialog = false;
      this.userLocalAddSign = false
      this.newSign={}
      this.hasManualSignature();
      if(refresh)this.getChapterList()
    },
    tabHand () {
      try {
        if (this.$route.path === this.menus[0].route.path) return
        if (isInDingTalk) {
          this.$router.push({ path: this.menus[0].route.path }, () => { }, () => { })
        }
      } catch (err) {
        console.log('tplRouter_err', err)
      }
    },
    //获取手写章
    hasManualSignature () {
      ApiMethods.UserTagController.hasManualSignatureObj().then(res => {
        if (!(this.$store.getters.authUser.identityAuth > -1)) return this.authDialog = true;
        if (!res.success) return this.$message.error(res.description)
        this.ManualSignatureList = res.data;
        this.ManualSignatureList.imgSrc = fileOperShow(
          this.ManualSignatureList.handSignUrl
        );
      });
    },
    /**
     * 创建签章
     * @param {number} type - 创建类型； 0: 本地上传； 1: 在线制作
     * 根据当前用户的身份认证状态决定行为：
     * 如果用户已通过身份认证（identityAuth > -1），则设置 isAddSign 为 true；
     * 否则，显示认证对话框（authDialog 设置为 true）。
     */
    gotoAuth (type) {
      if (this.$store.getters.authUser.identityAuth > -1) {
        type === 1 ? this.isAddSign = true : this.localAddSign = true;
      } else {
        this.authDialog = true;
      }
    },
    //个人签字上传图片
    addUserLocalSignFn() {
      this.handWritingChapterInfo.uid = "";
      this.userLocalAddSign = true;
    },
    // 修改签章名字
    updateSeal () {
      this.$refs.updateSeal.validate(val => {
        if (!val || val === "false") return false;

        EntSignController.updatePreSealName(this.updateInfo)
          .then(() => {
            var signId = this.updateInfo.signId;
            this.chapterList.forEach(t => {
              if (t.signId === signId) {
                return (t.signName = this.updateInfo.chapterName);
              }
            });
            this.isUpdateSeal = false;
          })
          .catch(err => {
            this.$message.error(err.description || "签章修改失败");
          });
      });
    },
    // 打开修改章的弹窗
    openFileUploadDialog (seal) {
      if (!seal) return false;
      // 如果签章中包含color字段，说明是本地上传的带有规格信息的章；否则就原逻辑处理
      if(seal.color){
        this.newSign = seal;
        this.localAddSign=true;
      }else{
        this.updateInfo = {
          signId: seal.signId,
          chapterName: seal.signName,
          sealUrl: seal.signUrl
        };
        this.isUpdateSeal = true;
      }
    },
    // 设置默认章
    setDefaultSeal (signId) {
      if (!signId) return false;

      EntSignController.setPreDefaultSeal(signId).then(() => {
        this.getChapterList();
      });
    },
    //sho手写章编辑// 修改手写签
    handWritingChapterEdit () {
      //newSign
      ApiMethods.UserTagController.getSignatureParams().then(respon => {
        let obj = respon;
        if (typeof obj === "string") {
          obj = eval("(" + obj + ")");
        }
        if (obj.success === true || obj.success === "true") {
          let data = obj.data;
          ApiMethods.UserTagController.hasManualSignatureObj(data).then(res => {
            res = res.data;
            const currentAuthUser = this.$store.getters.currentAuthUser
            const signName = currentAuthUser.name
            let url = `${GlobalConfig.domain.junziqianH5Op}/handSign?signNo=${data.signNo}&sign=${data.sign}&ts=${data.ts}&uid=${data.uid}&formTo=personSet&signName=${signName}`;
            url += res.updateTime ? `&updateTime=${res.updateTime}` : "";
            this.handWritingChapterInfo = {
              url: url,
              ts: data.ts,
              sign: data.sign,
              signNo: data.signNo,
              updateTime: res.updateTime || "",
              formTo: "personSet",
              uid: data.uid,
            };
            if(res.handSignUrl){
              this.handWritingChapterInfo.signUrl = `${GlobalConfig.domain.junziqianH5Op}/fileOper/show?targetId=${res.handSignUrl.targetId}&fileType=${res.handSignUrl.fileType}&sign=${res.handSignUrl.sign}&ts=${res.handSignUrl.ts}`
            }
            this.visibleSealDialog = true;
            this.isSealModifi();
          });
        } else {
          this.$message.error(res.description);
        }
      });
    },
    // 手写章后，轮询签章是否修改
    isSealModifi () {
      if (!this.handWritingChapterInfo) return false;
      ApiMethods.UserTagController.pollingSignatureStatus(
        this.handWritingChapterInfo
      )
        // UserSign.syncHandStatus(this.handWritingChapterInfo)
        .then(({ data }) => {
          if (data || data === "true") {
            window.location.reload();
          } else {
            setTimeout(() => {
              this.isSealModifi();
            }, 3000);
          }
        })
        .catch(err => {
          this.$message.error(err.description || "数据初始化失败");
        });
    },
    // 删除章
    delChapter (signId) {
      this.$confirm("确认删除签章?", "系统提示", {
        showCancelButton: true,
        showConfirmButton: true,
        type: "warning"
      })
        .then(() => {
          this.loadingStart();
          EntSignController.delPreSeal(signId)
            .then(data => {
              this.loadingClose();
              this.getChapterList();
              this.$message.success("签章删除成功");
            })
            .catch(err => {
              this.loadingClose();
              this.$message.error(err.description || "数据初始化失败");
            });
        })
        .catch();
    },
    // 生成章
    createSeal () {
      this.$refs.sealForm.validate(val => {
        if (!val || val === "false") return false;
        this.loadingStart();
        EntSignController.createPreSeal(this.sealParam)
          .then(data => {
            this.loadingClose();
            this.$message.success("签章生成成功");
            this.isAddSign = false;
            this.getChapterList();
            this.sealParam = {
              fontType: 0,
              color: 0,
              path: 0,
              chapterName: "",
              signId: null
            };
          })
          .catch(err => {
            this.loadingClose();
            this.$message.error(err.description || "签章生成失败");
          });
      });
    },
    // 获取预览章的url
    getPreviewSeal () {
      EntSignController.previewSeal(this.sealParam)
        .then(({ data }) => {
          this.previewSealUrl = "data:image/png;base64," + data;
        })
        .catch(err => {
          if (this.$store.getters.authUser.identityAuth > -1) {
            this.$message.error(err.description || "初始化数据失败");
          }
        });
    },
    // 获取章列表
    getChapterList () {
      this.loadingStart();
      EntSignController.getAllPreSeal()
        .then(data => {
          let list = data.data;
          if (!data.data || !data.data.length) {
            this.chapterList = [];
          }
          this.defalutChapter = data.data[0];
          list.shift();

          list.forEach(t => {
            t.signUrl = fileOperShow(t.signUrl);
          });
          list.forEach((t, i) => {
            if (t.defaultChapter && t.defaultChapter === 1) {
              var defSeal = list.splice(i, 1);
              list.unshift(t);
            }
          });
          this.chapterList = list;
          this.loadingClose();
        })
        .catch(() => {
          this.loadingClose();
        });
    },
    loadingStart () {
      this.loadingClose();
      this.loading = this.$loading({
        lock: true
      });
    },
    loadingClose () {
      if (this.loading) this.loading.close();
    }
  }
};
</script>

<style lang="less" scoped>
.person-set {
  height: 100%;
  border: 1px solid #f0f0f0;
  overflow-y: auto;

  .update-seal {
    .seal-show {
      box-sizing: border-box;
      width: 200px;
      height: 200px;
      text-align: center;
      line-height: 200px;
      padding: 10px;
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      margin-bottom: 20px;
      overflow: hidden;

      img {
        max-width: 100%;
        max-height: 100%;
        border: 0;
        vertical-align: middle;
      }
    }

    .footer {
      margin-bottom: 30px;
      .btn {
        width: 120px;
      }
    }
  }

  .add-seal-box {
    .seal-dome {
      display: inline-block;
      width: 130px;
      height: 130px;
      text-align: center;
      line-height: 130px;
      margin-right: 20px;
      margin-bottom: 20px;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;

      &.active {
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
      }
    }

    .blue-seal {
      display: inline-block;
      width: 58px;
      height: 26px;
      border-radius: 2px;
      background-color: #0000ff;
    }

    .red-seal {
      display: inline-block;
      width: 58px;
      height: 26px;
      margin-right: 20px;
      border-radius: 2px;
      background-color: #ed1c1c;
    }

    .priview-img {
      box-sizing: border-box;
      width: 300px;
      height: 300px;
      line-height: 300px;
      text-align: center;
      border: 1px solid #f18a89;
      border-radius: 4px;
    }
  }

  .ent-dialog {
    .sign-tip {
      padding: 20px;
      color: #a1a1a1;
      line-height: 150%;
      ol {
        list-style-position: outside;
        margin-left: 30px;
      }
    }
    .upload-sign {
      position: relative;
      padding: 10px;
      border: 1px dashed #b4b4b4;
      text-align: center;
      color: #a1a1a1;
      font-size: 16px;
      height: 110px;
      line-height: 110px;
      overflow: hidden;
      cursor: pointer;
      i {
        vertical-align: middle;
        font-size: 64px;
      }
      img {
        max-width: 90px;
        max-height: 90px;
        vertical-align: middle;
      }
      input {
        position: absolute;
        display: inline-block;
        width: 100%;
        height: 400px;
        top: -20px;
        left: 0;
        opacity: 0;
        cursor: pointer;
      }
    }
    .ent-form {
      width: 80%;
      margin: 0 auto;
    }
  }

  .box {
    padding: 20px;

    .card {
      width: 250px;
      position: relative;
      margin: 0 auto;
      .seal-type {
        display: inline-block;
        box-sizing: border-box;
        position: absolute;
        top: 10px;
        left: 20px;
        cursor: pointer;
      }

      .add-sign {
        height: 140px;
        line-height: 140px;
        text-align: center;
        cursor: pointer;
        i {
          font-size: 64px;
          vertical-align: middle;
        }
      }

      .bottom {
        padding: 10px 8px;
        background-color: #f8f8f8;
        border-top: 0;
        color: #333;
        font-size: 12px;
        text-align: left;

        .add {
          cursor: pointer;
        }

        .action span {
          margin-left: 5px;
          cursor: pointer;
        }
      }

      .img-box {
        text-align: center;
        height: 140px;
        line-height: 140px;
        img {
          max-height: 90px;
          vertical-align: middle;
        }
      }

      .del-sign {
        display: none;
        position: absolute;
        color: #cccccc;
        right: 5px;
        top: 5px;
        font-size: 18px;
        cursor: pointer;
      }
    }

    .card:hover {
      .del-sign,
      .del-sign:hover {
        display: inline-block;
      }
    }

    p.sign-name {
      width: 250px;
      line-height: 20px;
      height: 20px;
      margin: 5px 0;
    }
  }

  h4 {
    margin: 0;
    padding: 12px;
    background-color: #f8f8f8;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
}

.return-a {
  margin-left: 20px;
  &:hover {
    color: #ec1c1c;
  }
}

.box-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-left: -20px;
  margin-top: -15px;
  padding: 15px;
  /*&:last-child {*/
  /*  margin-bottom: 130px;*/
  /*}*/
  .temone {
    margin-left: 20px;
    margin-top: 15px;
    width: 175px;
    text-align: center;
    align-items: center;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 4px;
    /*height: 140px;*/
    &.add {
      cursor: pointer;
      height: 140px;
      line-height: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
      }
    }
    p {
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 10px;
      width: 100%;
      font-family: Source Han Sans SC;
      box-sizing: border-box;
      height: 35px;
      line-height: 35px;
      background: rgba(239, 239, 239, 1);
      color: rgba(41, 2, 2, 0.65);
    }
    .t-box {
      position: relative;
      width: 100%;
      height: 105px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      &:hover {
        .msk {
          width: 100%;
          height: 100%;
          opacity: 1;
        }
      }
      .y-img {
        /*width: 106px;*/
        /*min-height: 100px;*/
        width: 96px;
        height: auto;
        display: block;
        margin: 8px auto 7px auto;
      }
      .msk {
        transition: all ease 0.2s;
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        padding: 8px 8px;
        box-sizing: border-box;
        z-index: 10;
        span {
          cursor: pointer;
          float: right;
          color: #ffffff;
          font-size: 20px;
          margin-left: 10px;
          &:hover {
            color: rgba(236, 28, 28, 1);
          }
        }
        .setmr-btn {
          float: left;
          font-size: 14px;
          margin-left: 0;
        }
      }
      .mr-label {
        position: absolute;
        left: 0;
        top: 0;
        font-size: 12px;
        color: rgba(236, 28, 28, 1);
        z-index: 5;
      }
    }
    .el-icon-plus {
      cursor: pointer;
      color: #c9bfbf;
      font-size: 80px;
    }
  }
}
.popover-style {
  height: 100px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /deep/ .el-button + .el-button {
    margin-left: 0;
  }
}
.info_box {
  width: 100%;
  margin: 10px 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  .approve_info {
    cursor: pointer;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/personSet.vue